import { Alert, Badge } from "@/shared/components/MDX/MDXComponents";

# ⚡ راهنمای ثبت سفارش تولید جدید

پلتفرم کارخانه‌سازی میمزاد (Mimzad Manufacturing Platform) — سند راهنمای ثبت سفارشات

<Badge type="gold">سند استاندارد کاربری</Badge> <Badge>راهنمای جامع</Badge>

## 📋 فهرست مطالب و دسترسی سریع

1. [مقدمه](#sec-intro)
2. [مراحل ثبت سفارش تولید](#sec-step1)
3. [نکات کلیدی ثبت سفارش](#sec-step2)

---

## 1. مقدمه

ایجاد **سفارش تولید (Production Order)** اولین گام اجرایی برای آغاز عملیات ساخت در کارگاه است.
سفارش تولید می‌تواند بر اساس نیاز انبار (MTS - Make to Stock) یا بر اساس سفارش مستقیم مشتری (MTO - Make to Order) صادر شود.

<Alert type="info">
  پیش‌نیاز: برای ثبت سفارش تولید، باید محصول مورد نظر دارای لیست قطعات تایید شده (BOM) و مسیر تولید (Routing) فعال باشد.
</Alert>

---

## 2. مراحل ثبت سفارش تولید

جهت صدور دستور کار تولیدی جدید، مراحل زیر را طی کنید:

1. وارد فرم **سفارش تولید جدید** شوید.
2. از بخش **محصول (Product)**، قطعه یا محصول نهایی که قصد تولید آن را دارید انتخاب کنید.
3. **تعداد/مقدار (Quantity)** مورد نیاز برای تولید را وارد کنید. سیستم به صورت خودکار مواد اولیه مورد نیاز را محاسبه خواهد کرد.
4. **موعد تحویل (Due Date)** را مشخص کنید تا برنامه‌ریزی تولید به درستی انجام شود.
5. **اولویت سفارش** را تنظیم کنید:
   - `Low` (پایین)
   - `Normal` (عادی)
   - `High` (بالا)
   - `Urgent` (فوری - جهت شکستن صف‌های تولید)
6. در صورت نیاز، توضیحات فنی یا نکات مورد نظر برای پرسنل خط را در بخش توضیحات درج کنید.
7. روی دکمه **ثبت سفارش** کلیک کنید.

---

## 3. نکات کلیدی ثبت سفارش

- پس از ثبت سفارش، وضعیت آن در حالت **پیش‌نویس (Draft)** قرار می‌گیرد.
- سفارشات پیش‌نویس قابلیت ویرایش و تغییر در لیست قطعات تخصیص‌یافته را دارند.
- تا زمانی که سفارش به حالت **آزاد شده (Released)** در نیاید، در تابلوی کارگاه و کارتابل اپراتورها نمایش داده نخواهد شد.

<Alert type="tip">
  پیش از آزادسازی سفارش، اطمینان حاصل کنید که مواد اولیه کافی در انبار پایِ‌خط (WIP) موجود است، در غیر این‌صورت سفارش با کمبود (Shortage) مواجه شده و متوقف می‌گردد.
</Alert>
